import React from 'react'

function ArticleSearchResult(props) {
  return (
    <div className="container">
      <div className="columns">
        <div className="column is-8">
          <p className='title is-size-6 has-text-centered'>{props.data?.topic}</p>
        </div>
        <div className="column is-4">
          <button className="button m-2 btn" onClick={() => { props.handlePopup(props.data) }}>
            View
          </button>
        </div>
      </div>
    </div>
  )
}

export default ArticleSearchResult